module.exports = __webpack_public_path__ + "static/devops01-84fe3f46c21dec16a4a9e16724acb42a.jpeg";